// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueAmap from 'vue-amap'
import router from './router/router'
import store from './store/store.js'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import ElementUI from 'element-ui'
import './assets/scss/element-variables.scss'
import './assets/scss/global.scss'
import 'babel-polyfill'
Vue.use(VueAmap)

Vue.prototype.$http = axios
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.use(ElementUI, {size: 'large', zIndex: 3000})

Vue.prototype.$http.interceptors.response.use(response => {
  if (response.config.url == "/client/sms/checkLogin") {
    return response;
  }
  let res = response.data;
  let isLoginPage = router.currentRoute.fullPath.indexOf('loginPage') > -1;
  if (!isLoginPage && res.message == '0000') {
    router.push("/managePage/loginPage");
  }
  return response;
}, err => {
  console.log(err);
});

Vue.config.productionTip = false

VueAmap.initAMapApiLoader({
  key:"35dbe243d669f8fbc33cd46defb43d6d",
  plugin:[
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.Geolocation",
    "AMap.Geocoder",
    "AMap.AMapUI"
  ]
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js